// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4448":"ffd983f68a1b5887","5466":"8cf28f18265b94d1","5895":"edc92ec24d6493a4","6360":"7093ed2ed43d366e","8922":"da4f21b75a329fc3"}[chunkId] + ".css";
};